import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, Button } from '@mui/material';
import CompanyJobPostImage from '../assets/screenshots/JobPostScreen.svg';
import { ReactComponent as HandPointingIcon } from '../assets/icons/HandPointing.svg';
// import CloseIcon from '@mui/icons-material/Close';
//import CompanyStep3Image from '../assets/screenshots/CompanyStep3Image.svg'
// import JobPage from '../assets/screenshots/JobPage.svg';
// import Logo from '../assets/icons/tennavi_scout_logo2026_4.png';
import ModalWrapper from './ModalWrapper';
//import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';

export default function CompanyStepTwoRegistrationGuard({ open, onClose, onConfirm }) {
//  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleClose = () => {
    localStorage.removeItem('first_login'); // Remove first_login from local storage
    onClose && onClose();
  };

  const handleOk = () => {
    try {
      if (onConfirm) onConfirm();
    } catch (e) {
      // swallow handler errors to ensure navigation proceeds
      // eslint-disable-next-line no-console
      console.error('onConfirm handler error', e);
    }
    handleClose();
    //navigate('/company/jobinfomanagement');
  };

  return (
    <ModalWrapper open={open} onClose={handleClose} smWidth={580} ariaLabel="searchsettings-guard-title" ariaDesc="searchsettings-guard-desc">
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          // border: '2px solid',
          // borderColor: '#2F5FE7',
        }}
      >
        {/* Close (X) */}
        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', top: 8, right: 8, color: (t) => t.palette.grey[700] }}
        >
          <CloseIcon />
        </IconButton> */}

        <Stack spacing={2.5} alignItems="center">
          {/* Logo */}
          {/* <Box aria-hidden>
            <img src={Logo} alt="Logo" style={{ width: 100 }} />
          </Box> */}

          {/* Title */}
          <Typography
            id="searchsettings-guard-title"
            component="h2"
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              fontWeight: 700,
              fontSize: { xs: 18, sm: 24 },
              color: '#000',
              letterSpacing: 0.5,
              lineHeight: 1.35,
            }}
          >
            求人を掲載するとスカウトを開始できます​
            {/* Welcome to Tennavi Accounting */}
          </Typography>

          {/* Image with animated icon and label above */}
          <Box sx={{ position: 'relative', width: 530, marginTop: 2 }}>
            {/* Animated icon and label overlay */}
            <Box
              sx={{
                position: 'absolute',
                top: -8,
                right: -10,
                zIndex: 2,
                p: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
              }}
            >
              <Typography
                sx={{
                  fontSize: 16,
                  color: '#000',
                  fontWeight: 700,
                  mb: 1.5,
                  lineHeight: 1,
                }}
              >
                ここから登録可能
              </Typography>
              <Box
                sx={{
                  animation: 'arrowBounce 1s infinite',
                  '@keyframes arrowBounce': {
                    '0%, 100%': { transform: 'translateY(0)' },
                    '50%': { transform: 'translateY(-12px)' },
                  },
                }}
              >
                <HandPointingIcon
                  sx={{
                    fontSize: 36,
                    color: '#ed3221ff',
                    transform: 'rotate(180deg)',
                  }}
                />
              </Box>
            </Box>
            {/* Image with Skeleton Loader */}
            {!imageLoaded && <Skeleton variant="rectangular" width={530} height={300} />}
            <img
              src={CompanyJobPostImage}
              alt="Logo"
              style={{ width: 530, display: imageLoaded ? 'block' : 'none', marginTop: 50 }}
              onLoad={() => setImageLoaded(true)}
            />
          </Box>

          {/* CTA (exact label as image) */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'center', // centers horizontally
          }}>
              <Button
                variant="contained"
                onClick={handleOk}
                className="yellowButton"
                sx={{
                  mt: 1,
                  width: { xs: '100%', sm: 110 },
                  height: 33,
                  fontWeight: 500,
                  fontSize: { xs: 14, sm: 16 },
                }}
              >
                OK
              </Button>
            </Box>
        </Stack>
      </Box>
    </ModalWrapper>
  );
}

CompanyStepTwoRegistrationGuard.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCompanyInfoClick: PropTypes.func,
  onJobInfoClick: PropTypes.func,
};